import React, { Component } from "react";
import PropTypes from "prop-types";
// Components
import Tooltip from "../Tooltip";
// Styles
import styles from "./Card.css";

class Card extends Component {
  constructor(props) {
    super(props);

    this.areaRef = React.createRef();
  }

  handleCopyToClipboard = (event) => {
    this.areaRef.select();
    document.execCommand("copy");
  };

  createTextareaRef = (ref) => {
    this.areaRef = ref;
  };

  render() {
    const {
      allowCopy,
      buttonAction,
      buttonLabel,
      description,
      mainDescription,
      strikeThrough,
      subTitle,
      title,
      tooltipMessage,
      value
    } = this.props;

    return (
      <div className="well" style={styles.container}>
        <div style={styles.title}>{title}</div>
        <div style={styles.subTitle}>{subTitle}</div>
        <div style={styles.mainDescription}>
          <textarea
            id="textarea"
            readOnly
            ref={this.createTextareaRef}
            style={{
              ...styles.textarea,
              width: `${allowCopy ? "90%" : "100%"}`
            }}
            value={mainDescription}
          />
          {allowCopy && (
            <Tooltip message={tooltipMessage} position="top">
              <a className="btn btn-link" onClick={this.handleCopyToClipboard} type="button">
                <i className="fa fa-copy" />
              </a>
            </Tooltip>
          )}
        </div>
        <div style={styles.bottomContainer}>
          <div style={styles.description}>{description}</div>
          <div style={styles.buttonContainer}>
            {buttonLabel && (
              <a className="btn btn-primary" onClick={buttonAction}>
                {buttonLabel}
              </a>
            )}
            {strikeThrough ? <del>{value}</del> : <span>{value}</span>}
          </div>
        </div>
      </div>
    );
  }
}

Card.defaultProps = {
  allowCopy: false,
  buttonAction: () => {},
  strikeThrough: false
};

Card.propTypes = {
  allowCopy: PropTypes.bool,
  buttonAction: PropTypes.func,
  buttonLabel: PropTypes.string,
  description: PropTypes.string,
  mainDescription: PropTypes.string,
  price: PropTypes.string,
  strikeThrough: PropTypes.bool,
  subTitle: PropTypes.string,
  title: PropTypes.string,
  tooltipMessage: PropTypes.string
};

export default Card;
